/* @flow */
import * as React from 'react'
import EmailSummary from './EmailSummary'
import EmailFull from './EmailFull'
import { isResponseFull } from './EmailUtils'
import { EmailConsumer } from '../../../context/Email'
import { type WidgetType } from './Types'

type InnerComponentProps = {|
  embedded: boolean,
  widget: WidgetType,
  googleAnalytics?: any
|}

export default class Email extends React.PureComponent<InnerComponentProps> {
  render () {
    const {
      embedded = false,
      widget,
      googleAnalytics
    } = this.props

    return (
      <EmailConsumer googleAnalytics={googleAnalytics}>
        { ({ handleLogoutClick, inbox, isLoading }) =>
          <div id={widget.name}>
            {isResponseFull(inbox) ? (
              <EmailFull
                embedded={embedded}
                handleLogoutClick={handleLogoutClick}
                inbox={inbox}
                isLoading={isLoading}
                widget={widget}
              />
            ) : (
              <EmailSummary googleAnalytics={googleAnalytics} embedded={embedded} widget={widget} inbox={inbox} loading={isLoading}/>
            )}
          </div>
        }
      </EmailConsumer>
    )
  }
}
